export const environment = {
    production: false,
    baseUrl: '//bimbo.damianocancemi.com'
};